// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import { EnergySource } from "shared/types/parameter";
import { DashboardPanel } from "types";

// uses webpack definitions
declare const IS_CLOUD: boolean;

export enum GraphViewMode {
  BAR = "bar",
  LINE = "line",
  DIGITAL = "digital",
  TABLE = "table",
}

export enum PowerViewMode {
  HIERARCY = "hierarchy",
  SANKEY = "sankey",
  PIE = "pie",
  TABLE = "table",
}

export enum EmobilityViewMode {
  CHARGERLIST = "chargerlist",
  RFIDLIST = "rfidlist",
}

export type Category = string | null; // null for unmapped categories

// this structure holds the subset of all persistent selections of one given site,
// which is dependent on the dashboard panel

// this structure holds all persistent selections of one given site
export interface ISiteSelection {
  // dashboard selection, based on index in dashboard panel
  dashboardPanel: (DashboardPanel | undefined)[]; // undefined = automatic
  eMobilityViewMode?: EmobilityViewMode; // selected eMobility info (Chargers or Cards)
  // selection of various items within various views
  energySource?: EnergySource | undefined; // energy source in power or trend view; undefined for all
  category?: Category | undefined | null; // selected category-filter; undefined for all, null for unmapped
  controlCircuitId?: number; // selected regulation circuit of monitor
  tariffCircuitIds?: number[]; // selected tariff circuits in trend view
  isHierarchyViewMode?: boolean; // if true, hierarchy-mode is shown in TreeViewDropDown, otherwise as normal tree
  hierarchyId?: number | null | undefined; // selected parent tariff circuit, null for root level
  inputs?: number[];
  outputs?: number[];
  trendMonitor?: number;
  // persistent view-modes
  graphViewMode?: GraphViewMode; // selected graph-view-mode (list, lines, bars,...)
  powerViewMode?: PowerViewMode; // selected power-view-mode (hierarchy, sankey, pie, list,....)
}

export interface IStateCached {
  version: number; // needed to detect changes in state structure for migrations
  clientToken: string; // id to register for controller live data; also authorizes proxy access

  selectedSite: number | undefined; // selected site id
  favoriteSites?: number[]; // ids of favorite sites
  siteSelection?: ISiteSelection[]; // persistent selections for each site, siteId as array index
}

/* initial state */
export const INITIAL_STATE: IStateCached = {
  version: 0,
  // cryptographically strong: the token doubles as a proxy bearer credential
  clientToken: crypto.randomUUID() ?? Math.random().toString(36).substring(2, 15),
  selectedSite: IS_CLOUD ? undefined : 1,
};
